var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoEn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118.49,
    height: 118.49,
    viewBox: "0 0 118.49 118.49",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m195.25 240.94c0.39542-0.0599 1.0425-0.0599 1.4379 0s0.0719 0.10891-0.71893 0.10891-1.1144-0.049-0.71894-0.10891z",
    fill: "#f0f",
    opacity: 0.01
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-160.01 -4.505)",
    fill: "#006178"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 219.25,
    cy: 63.75,
    r: 59.246,
    fill: "#006178"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.84408 0 0 .87185 -30.297 3.5051)",
    fill: "#fff",
    "aria-label": "lth"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m80.566 88.237h-8.2523v-49.405h8.2523z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.39 81.795v6.4426q-3.6918 0.79627-5.7187 0.79627-3.3299 0-5.7187-1.303-2.3888-1.3392-3.5108-3.6194-1.0858-2.3164-1.0858-7.0941v-18.93h-4.5605v-6.4064h5.031l0.76008-9.5191 6.7683-0.6153v10.134h7.3474v6.4064h-7.3474v17.844q0 3.4384 1.2306 4.7052 1.2668 1.2306 4.7414 1.2306 0.97724 0 2.0631-0.07239z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144.59 88.237h-8.2523v-23.924q0-3.8728-1.6649-5.4291-1.6287-1.5925-3.8366-1.5925-3.5108 0-5.8997 2.787-2.3888 2.787-2.3888 9.1933v18.966h-8.2523v-49.405h8.2523v19.255q3.0765-7.8903 10.786-7.8903 11.256 0 11.256 12.921z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEn);
export default __webpack_public_path__ + "static/media/logo-en.347754e9a8fde68bbfce9ee903a6c83d.svg";
export { ForwardRef as ReactComponent };